import React, { Fragment } from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import { format } from '@olxbr/mojo-jojo/utils/string';

import { PointOfSaleContext } from '@olxbr/mojo-jojo/contexts';

const Bold = styled.span`
  font-weight: bold;
`;

const Danger = styled(Bold)`
  color: #FF4444;
`;

const LimitSubtitle = styled(ReactMarkdown)`
  strong {
    font-weight: bold;
  }
`;

const NoBalance = () => (
  <PointOfSaleContext>
    {({ contentData, limitsData }) => (
      contentData.limitSubtitle ? (
        <Fragment>
          <LimitSubtitle source={format(contentData.limitSubtitle, { consumption: limitsData.consumption.value, categoryName: limitsData.consumption.categoryName, dueDate: limitsData.consumption.dueDate })} />
        </Fragment>
      ) : (
        <p>
          Esse foi seu <Danger>último anúncio gratuito</Danger> nessa categoria, esse mês.
        </p>
      )
    )}
  </PointOfSaleContext>
);

export default NoBalance;
